import { RuleId } from '@wix/a11y-rules';
import { areStructuresEqual, getHeadingStructure } from './heading-helpers';
export const getCrossHeadingStructureIssuesByBreakpoint = results => {
  const pageEntries = Object.values(results);
  const [firstPageResults] = pageEntries;
  if (!(firstPageResults != null && firstPageResults[RuleId.HEADING_STRUCTURE])) {
    return null;
  }
  const crossIssuesByBreakpoint = {};
  for (const firstResultRaw of firstPageResults[RuleId.HEADING_STRUCTURE]) {
    var _firstResult$metadata, _firstResult$result;
    const firstResult = firstResultRaw;
    const breakpointId = firstResult == null || (_firstResult$metadata = firstResult.metadata) == null ? void 0 : _firstResult$metadata.breakpointId;
    if (!breakpointId) {
      continue;
    }
    const firstHeadings = (_firstResult$result = firstResult.result) == null ? void 0 : _firstResult$result.allHeadings;
    if (firstHeadings === undefined || firstHeadings === null) {
      continue;
    }
    const firstStructure = getHeadingStructure(firstHeadings);
    const allPagesMatch = pageEntries.slice(1).every(page => {
      var _matchingResult$resul;
      const matchingResult = ((page == null ? void 0 : page[RuleId.HEADING_STRUCTURE]) ?? []).find(r => {
        var _r$metadata;
        return (r == null || (_r$metadata = r.metadata) == null ? void 0 : _r$metadata.breakpointId) === breakpointId;
      });
      const currentHeadings = matchingResult == null || (_matchingResult$resul = matchingResult.result) == null ? void 0 : _matchingResult$resul.allHeadings;
      if (currentHeadings === undefined || currentHeadings === null) {
        return false;
      }
      const currentStructure = getHeadingStructure(currentHeadings);
      return areStructuresEqual(firstStructure, currentStructure);
    });
    if (allPagesMatch) {
      crossIssuesByBreakpoint[breakpointId] = firstResult;
    }
  }
  return Object.keys(crossIssuesByBreakpoint).length > 0 ? crossIssuesByBreakpoint : null;
};
//# sourceMappingURL=get-cross-heading-structure-issues.js.map